import * as React from 'react';
import { makeIcon } from './makeIcon';
const Check = props => (React.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16" }, props),
    React.createElement("polygon", { points: "14.7713199 2 4.95884603 11.5966813 1.22868046 7.94854812 0 9.15020749 4.95884603 14 16 3.20165971" })));
export const CheckIcon = makeIcon('check')(Check);
//# sourceMappingURL=Check.js.map